import { render } from "./PokemonPicture.vue?vue&type=template&id=7acde8fb&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=7acde8fb&scoped=true&lang=scss"

import exportComponent from "/home/diavolo/Projects/yachay/pokemon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7acde8fb"]])

export default __exports__